<template>
  <g
    :transform="`translate(${(position.map_x * originalImageWidth)},${(position.map_y * originalImageHeight)})`"
    class="position-container"
    :class="positionClassList"
  >
    <rect
      :id="position.svg_rect_id"
      class="position"
      :width="position.width_percent"
      :height="position.height_percent"
      :rx="position.svg_rect_rx"
      @click.stop="selectPosition"
    ></rect>
    <clipPath :id="position.svg_rect_clip_path_id">
      <use :xlink:href="position.svg_rect_clip_path_href"></use>
    </clipPath>
    <svg
      v-if="isCheckingOut"
      :width="position.width_percent"
      :height="position.height_percent"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <clipPath :id="position.svg_clip_path_id">
        <rect
          width="100"
          height="100"
          :rx="position.border_radius_percent"
        />
      </clipPath>
      <polygon
        class="position-inner-right-triangle"
        points="0,100 100,0 100,100"
        :clip-path="position.svg_polygon_clip_path"
        @click.stop="selectPosition"
      />
    </svg>
    <text
      :clip-path="position.svg_text_clip_path"
      class="position-text"
      dominant-baseline="middle"
      text-anchor="middle"
      :x="position.svg_text_x"
      :y="position.svg_text_y"
    >
      <tspan :font-size="labelFontSize">
        {{ position.map_name }}
      </tspan>
    </text>
  </g>
</template>

<script>
import { svgTextFontSize } from '@/utils/svgText'

export default {
  name: 'MapPosition',
  props: {
    position: Object,
    availability: Array,
    showAvailability: Boolean,
    isOccupied: Boolean,
    isSelected: Boolean,
    hasSelectedPosition: Boolean,
    selectedCategoryId: Number,
    mapImageAspectRatio: Number
  },
  data: () => ({
    originalImageWidth: 1000
  }),
  computed: {
    mapPositionsGreenAvailability: function () {
      return this.$store.state.localSettings.mapPositionsGreenAvailability
    },
    originalImageHeight: function () {
      return this.originalImageWidth * this.mapImageAspectRatio
    },
    positionWidth: function () {
      return this.position.width * this.originalImageWidth
    },
    positionHeight: function () {
      return this.position.height * this.originalImageHeight
    },
    labelFontSize: function () {
      return svgTextFontSize(this.position.map_name, this.positionWidth, this.positionHeight)
    },
    positionClassList: function () {
      if (this.showAvailability) {
        if (this.availability.length === 0) {
          return {}
        }
        const positionAvailability = this.availability[this.position.id]
        if (!positionAvailability) {
          return {}
        }
        return {
          'white-availability': !this.mapPositionsGreenAvailability,
          'is-selected': this.isSelected,
          'not-selected-category': !this.isSelectedCategory,
          'not-selected-position': this.hasSelectedPosition && !this.isSelected,
          'is-available': positionAvailability.is_available,
          'is-checkingout': this.isCheckingOut,
          'is-blocked': positionAvailability.status === 'blocked',
          'is-reserved': positionAvailability.status === 'reserved'
        }
      } else {
        return {
          'is-selected': this.isSelected,
          'not-selected-category': !this.isSelectedCategory,
          'not-selected-position': this.hasSelectedPosition && !this.isSelected,
          'is-occupied': this.isOccupied
        }
      }
    },
    isCheckingOut: function () {
      return this.showAvailability && this.availability[this.position.id]?.status === 'bookable'
    },
    isSelectedCategory: function () {
      return !this.selectedCategoryId || this.selectedCategoryId === this.position.category_id
    }
  },
  methods: {
    selectPosition: function (clickEvent) {
      this.$emit('select-position', { position: this.position, clickEvent })
    }
  },
  watch: {}
}
</script>
